import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TagifyModule } from 'ngx-tagify';
import { PaginationModule } from '../layout/pagination/pagination.module';
import { GroupLinksComponent } from './group-links.component';
import { CreateComponent } from './modals/create/create.component';
import { DeleteComponent } from './modals/delete/delete.component';
import { EditComponent } from './modals/edit/edit.component';

@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    FormsModule,
    ReactiveFormsModule,
    TagifyModule,
    GroupLinksComponent,
    DeleteComponent,
    CreateComponent,
    EditComponent,
  ],
  exports: [GroupLinksComponent],
})
export class GroupLinksModule {}
